export const ENDPOINTS_CACHE_KEY = 'endpoints'
export const PKCE_CACHE_KEY = 'pkce-verifier'
export const STATE_CACHE_KEY = 'auth-state'
